module.exports = __webpack_public_path__ + "img/flfw_07.b3aee80a.png";